import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseJson',
})
export class ParseJsonPipe implements PipeTransform {
  transform(value: string): Record<string, any> {
    try {
      return JSON.parse(value);
    } catch (err) {
      return {};
    }
  }
}
